import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { TextAlign, ZIndex } from '@/interface/enum';
import { useLocalStorage } from '@/libraries/composables/useLocalStorage';
import { getImage } from '@/libraries/helpers/imageHelper';
import { i18n } from '@/libraries/i18n';
import { useAccountStore } from '@/stores/accountStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

export function useBetBuilderTutorialPopup() {
    const { isBetBuilderEnabled, isBetBuilderTutorialEnabled } = storeToRefs(useFeatureToggleStore());
    const { isAsi } = storeToRefs(useRootStore());
    const { hashedAccountId } = storeToRefs(useAccountStore());

    const [showBetBuilderJackTimePopup, setShowBetBuilderJackTimePopup] = useLocalStorage(`betBuilderJTPopup:${hashedAccountId.value}`, true);
    const isShowPopup = computed(() => isBetBuilderEnabled.value && isBetBuilderTutorialEnabled.value && showBetBuilderJackTimePopup.value && isAsi.value);

    const imageGlob = import.meta.glob('../../../assets/images/betBuilder-hdp-popup/*.{png,webp}', {
        eager: true,
    });

    const imageUrl = computed(() => getImage(imageGlob, i18n.locale.value, 'EN'));

    const popupStyle = {
        zIndex: ZIndex.BetBuilderPopup,
        textAlign: TextAlign.Center,
    };

    function closePopup() {
        setShowBetBuilderJackTimePopup(false);
    }

    return {
        isShowPopup,
        closePopup,
        imageUrl,
        popupStyle,
    };
}
